import React from 'react';
import './App.css';
import { Calendar } from './Calendar';
import { CalendarDate } from './calendar.utils';

const startDay: CalendarDate = {
  month: 'February',
  date: 4,
  dayOfTheWeek: 'Thursday',
};
const endDay: CalendarDate = {
  month: 'March',
  date: 21,
  dayOfTheWeek: 'Sunday',
};

export function App() {
  return (
    <div className="grid grid-col-1 h-full w-full place-items-center">
      <header>
        <h1 className="text-3xl m-6 text-center">
          Zack's February/March 2021 Morning Habit Stack
        </h1>
        <p className="text-center p-4">
          This is an app I wrote to mess with React code && to keep track of
          whether I complete my "morning stack":
        </p>
        <ol className="list-inside list-disc px-24">
          <li>Wake Up</li>
          <li>1 hour <a href="https://epicreact.dev">Kent C. Dodd's Epic React course</a></li>
          <li>Run</li>
          <li>Shower</li>
          <li>Make Coffee</li>
          <li>Draw Out a Rough Schedule and Todos for the day</li>
        </ol>
      </header>
      <main className="grid grid-col-1 h-full w-full place-items-center p-8">
        <Calendar
          startDay={startDay}
          endDay={endDay}
          results={[
            'success',
            'success',
            'success',
            'success',
            'success',
            'success',
            'success',
            'success',
            'success',
            'success',
            'success',
            'success',
            'success',
            'success',
            'success',
            'success',
            'success',
            'success',
            'success',
            'success',
            'success',
          ]}
        />
        <hr />
        <div className="grid grid-cols-1 md:grid-cols-2">
          <div className="p-8 m-2">
            <p className="text-center text-lg">
              Want to learn how to make a habit-tracker calendar for yourself??
            </p>
            <p className="text-center text-lg">
              Checkout this tutorial to find out more:
            </p>
            <a
              className="transition duration-500 px-16"
              href="https://dev.to/zackderose/creating-a-habit-tracker-app-using-typescript-react-and-tailwind-183c"
            >
              <div className="transition duration-500 rounded-lg shadow-lg hover:shadow-2xl bg-gray-100 z-50 hover:ring-4 transform hover:-translate-y-1">
                <img
                  className="block h-48 w-full rounded-t-lg object-cover"
                  src="https://res.cloudinary.com/practicaldev/image/fetch/s--1saMrR4l--/c_imagga_scale,f_auto,fl_progressive,h_420,q_auto,w_1000/https://dev-to-uploads.s3.amazonaws.com/i/i9u17ab1hjgmhsuyaghb.png"
                  alt="Creating a Habit Tracker App using Typescript, React, and Tailwind"
                />
                <h2 className="text-2xl font-extrabold p-4">
                  Creating a Habit Tracker App using Typescript, React, and
                  Tailwind
                </h2>
                <p className="text-lg p-4">February 21, 2021</p>
              </div>
            </a>
          </div>
          <div className="p-8 m-2">
            <p className="text-center text-lg">
              Want to learn more about my habit-stacking and goals??
            </p>
            <p className="text-center text-lg">
              {' '}
              Checkout the article that explains it all here:
            </p>
            <a
              className="transition duration-500 px-16"
              href="https://dev.to/zackderose/resolution-update-february-2021-284m#building-on-systemization"
            >
              <div className="transition duration-500 rounded-lg shadow-lg hover:shadow-2xl bg-gray-100 z-50 hover:ring-4 transform hover:-translate-y-1">
                <img
                  className="block h-48 w-full rounded-t-lg object-cover"
                  src="https://res.cloudinary.com/practicaldev/image/fetch/s--fPs_6pV9--/c_imagga_scale,f_auto,fl_progressive,h_420,q_auto,w_1000/https://dev-to-uploads.s3.amazonaws.com/i/eh6xn4v0hskt4ej9dqqg.png"
                  alt="Resolution Update: February 2021"
                />
                <h2 className="text-2xl font-extrabold p-4">
                  Resolution Update: February 2021
                </h2>
                <p className="text-lg p-4">February 7, 2021</p>
              </div>
            </a>
          </div>
        </div>
      </main>
      <footer className="flex flex-col align-center m-4">
        <h2 className="text-center">Other Links!!</h2>
        <ol className="text-white text-lg font-large flex flex-wrap justify-center p-22">
          <a
            href="https://zackderose.dev"
            className="transition duration-1000 rounded-md bg-gray-900 hover:bg-gray-800 shadow-lg m-2 hover:shadow-2xl hover:ring-4 transform hover:-translate-y-1"
          >
            <li className="flex flex-initial">
              <img
                className="h-8 w-8 m-2 place-self-center"
                src="https://zackderose.dev/assets/android-chrome-512x512.png"
                alt="zackderose.dev logo"
              />
              <span className="p-4 leading-none place-self-center">
                zackderose.dev
              </span>
            </li>
          </a>
          <a
            href="https://www.youtube.com/channel/UCIEY8ETWdW3EX-3nWE-T0dQ"
            className="transition duration-1000 rounded-md bg-red-500 hover:bg-red-400 shadow-lg m-2 hover:shadow-2xl hover:ring-4 transform hover:-translate-y-1"
          >
            <li className="flex flex-initial">
              <img
                className="h-8 w-8 m-2 place-self-center"
                src="https://i.pinimg.com/originals/de/1c/91/de1c91788be0d791135736995109272a.png"
                alt="YouTube logo"
              />
              <span className="p-4 pl-0 leading-none place-self-center">
                Zack's YouTube
              </span>
            </li>
          </a>
          <a
            href="https://twitter.com/zackderose"
            className="transition duration-1000 rounded-md bg-blue-300 hover:bg-blue-200 shadow-lg m-2 hover:shadow-2xl hover:ring-4 transform hover:-translate-y-1"
          >
            <li className="flex flex-initial">
              <img
                className="h-8 m-2 place-self-center"
                src="https://logos-world.net/wp-content/uploads/2020/04/Twitter-Logo.png"
                alt="Twitter logo"
              />
              <span className="p-4 -pl-1 leading-none place-self-center">
                Zack's Twitter
              </span>
            </li>
          </a>
          <a
            href="https://dev.to/zackderose"
            className="transition duration-1000 rounded-md bg-purple-800 hover:bg-purple-600 shadow-lg m-2 hover:shadow-2xl hover:ring-4 transform hover:-translate-y-1"
          >
            <li className="flex flex-initial">
              <img
                className="h-8 m-2 place-self-center"
                src="https://cdn1.iconfinder.com/data/icons/logos-and-brands-3/512/84_Dev_logo_logos-512.png"
                alt="Dev.to logo"
              />
              <span className="p-4 -pl-1 leading-none place-self-center">
                Zack's Dev.to
              </span>
            </li>
          </a>
        </ol>
      </footer>
    </div>
  );
}

export default App;
